module.exports = __webpack_public_path__ + "media/images/svg/home1-36a5d275cfbb26eac5ab784029674868.svg";